import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@otcmarketsgroup/otcm-ui-lib';
import { CircleAlert } from 'lucide-react';

const FieldError = ({ error, isFocus }) => {
  return (
    <Tooltip
      dark
      subtitle={error}
      placement='top-start'
      open={Boolean(isFocus)}
    >
      <CircleAlert color="var(--otc-warning)" size={16} />
    </Tooltip>
  );
};

FieldError.propTypes = {
  error: PropTypes.string,
  className: PropTypes.string,
  isFocus: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};

export default FieldError;
